import { AsyncPipe, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SessionIdleWarningService } from './session-idle-warning.service';

/** Minimal inactivity warning banner. All logic lives in SessionIdleWarningService. */
@Component({
  selector: 'app-session-idle-warning',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  template: `
    <div *ngIf="warning.warning$ | async" role="alertdialog" aria-live="assertive"
         style="position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:100000;background:#fff;border:1px solid #c00;padding:12px 16px;box-shadow:0 2px 8px rgba(0,0,0,.3)">
      <span>You will be signed out soon because of inactivity.</span>
      <button type="button" (click)="warning.staySignedIn()" [disabled]="warning.pending$ | async" style="margin-left:12px">Stay signed in</button>
      <div *ngIf="warning.error$ | async" role="alert" style="color:#c00;margin-top:8px">Could not extend your session. Please try again.</div>
    </div>`,
})
export class SessionIdleWarningComponent {
  readonly warning = inject(SessionIdleWarningService);
}
